export const GretaAIChatStripNoticeType = {
  Limit: 'limit',
  Outage: 'outage',
  Revoked: 'revoked',
}
